export class ImageTooSmallError extends Error {
  constructor(url, width, height, minWidth, minHeight) {
    super(
      `Image ${url} is ${width}x${height}, smaller than ${minWidth}x${minHeight}`
    );
    this.name = 'ImageTooSmallError';
    this.width = width;
    this.height = height;
  }
}

// minWidth/minHeight reject smaller images before they are encoded again.
export const getBase64ImageByUrl = (
  url,
  format = 'image/jpeg',
  quality = 0.92,
  { minWidth = 0, minHeight = 0 } = {}
) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.onload = function () {
      try {
        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;
        if (width < minWidth || height < minHeight) {
          reject(
            new ImageTooSmallError(url, width, height, minWidth, minHeight)
          );
          return;
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);

        const supportsQuality =
          format === 'image/jpeg' || format === 'image/webp';
        const dataURL = supportsQuality
          ? canvas.toDataURL(format, quality)
          : canvas.toDataURL(format);

        const base64 = dataURL.replace(
          /^data:image\/(png|jpg|jpeg|webp);base64,/,
          ''
        );
        resolve(base64);
      } catch (err) {
        reject(err);
      }
    };
    image.onerror = function () {
      reject(new Error(`Cannot load image: ${url}`));
    };
    image.src = url;
  });
};
